import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import H5 from '@/components/H5'
import RecommentResult from '@/components/RecommendResult'
import Search from '@/components/Search'
import Share from '@/components/Share'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/app',
      name: 'Index',
      component: resolve => require(['@/components/Index.vue'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/',
      name: 'H5',
      component: resolve => require(['@/components/H5.vue'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path:'/recommend',
      name:'Recommend',
      component:resolve => require(['@/components/RecommendResult.vue'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path:'/jdIdx',
        name:'JDIdx',
      component:resolve => require(['@/components/JDIdx.vue'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path:'/search',
      name:'Search',
      component:resolve => require(['@/components/Search.vue'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path:'/Detail',
      name:'Share',
      component:resolve => require(['@/components/Share.vue'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path:'/list',
      name:'List',
      component:resolve => require(['@/components/wxShare/List'], resolve),
      meta: {
        keepAlive: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js